import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesRoutingModule } from './pages-routing.module';
import { OpenDataComponent } from './open-data/open-data.component';
import { LicenzaComponent } from './licenza/licenza.component';
import { FAQComponent } from './faq/faq.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContattiComponent } from './contatti/contatti.component';
import { PubblicazioniComponent } from './pubblicazioni/pubblicazioni.component';


@NgModule({
  declarations: [OpenDataComponent, LicenzaComponent, FAQComponent, PrivacyPolicyComponent, ContattiComponent, PubblicazioniComponent],
  imports: [
    CommonModule,
    PagesRoutingModule
  ]
})
export class PagesModule { }
